import Joi from '@hapi/joi'

export const TappingCheckListReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name characters`
    }),
    divisionID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Please select valid Division`,
        "any.required": `Division required`
    }),
    date: Joi.string().invalid("").required().label("To Date"),
    jobTypeID: Joi.string().invalid("").required().label("Job Type").messages({
        "any.invalid": `Please select a Job Type`,
        "any.required": `Job Type required`
    }),
}